module.exports = __webpack_public_path__ + "static/media/log-in.5feb95b8.jpg";